import { render, staticRenderFns } from "./AddBookmarkModal.vue?vue&type=template&id=516a5dd3&"
import script from "./AddBookmarkModal.vue?vue&type=script&lang=js&"
export * from "./AddBookmarkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports